import { styled } from "@mui/material";

export const ScrollableContainer = styled("div")(({ theme }) => ({
  flexGrow: 1,
  // Assumes it's a child of a flex row container
  minWidth: 0,
  overflowY: "auto",
  paddingBlock: theme.spacing(4),
}));
